// extracted by mini-css-extract-plugin
module.exports = {"title":"Title-module--title--mdT1-","serif":"Title-module--serif--2HVvu","sans":"Title-module--sans--2Fm9t","subtitle":"Title-module--subtitle--1lP4H"};